import { render, staticRenderFns } from "./AbsencesEditorEmployeeSelectorDialog.vue?vue&type=template&id=48e3455e&scoped=true&lang=pug&"
import script from "./AbsencesEditorEmployeeSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./AbsencesEditorEmployeeSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AbsencesEditorEmployeeSelectorDialog.vue?vue&type=style&index=0&id=48e3455e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e3455e",
  null
  
)

export default component.exports